var _defs, _circle, _g, _g2, _circle2, _ellipse, _g3, _circle3, _circle4, _path, _rect, _rect2, _path2, _rect3, _path3, _rect4, _rect5, _circle5, _rect6, _g4, _rect7, _path4, _circle6, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "sh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 14,
    floodColor: "#1B3B6F",
    floodOpacity: 0.16
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sh2",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 8,
    floodColor: "#5E22D6",
    floodOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "map"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 36,
    width: 232,
    height: 168,
    rx: 24
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 164,
    r: 140,
    fill: "#EEF2FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#map)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 36,
    width: 232,
    height: 168,
    fill: "#E3EBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 92h232M44 150h232M110 36v168M196 36v168",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 120c60-6 90 30 150 10s60-40 82-36",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 104,
    width: 60,
    height: 34,
    rx: 6,
    fill: "#D6E2FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 48,
    width: 56,
    height: 34,
    rx: 6,
    fill: "#D6E2FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 160,
    width: 42,
    height: 34,
    rx: 6,
    fill: "#D6E2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 70c30 10 60 20 96 40",
    stroke: "#9B6BFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#sh2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206 54c-19 0-34 15-34 33 0 25 34 55 34 55s34-30 34-55c0-18-15-33-34-33z",
    fill: "#7130F0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 88,
    r: 12,
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206,
    cy: 148,
    rx: 14,
    ry: 4,
    fill: "#1B3B6F",
    opacity: 0.12
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#sh)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 150,
    width: 204,
    height: 118,
    rx: 20,
    fill: "#fff"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 190,
    r: 20,
    fill: "#F6F2FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 184,
    r: 7,
    fill: "#7130F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 201c3-7 8-10 13-10s10 3 13 10",
    stroke: "#7130F0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 178,
    width: 88,
    height: 10,
    rx: 5,
    fill: "#1B3B6F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 196,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#C9D2E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 226h168",
    stroke: "#EEF1F7",
    strokeWidth: 2,
    strokeDasharray: "4 5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 238,
    width: 14,
    height: 14,
    rx: 4,
    fill: "#F6F2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 241.5c0 4 2.5 6.5 6.5 6.5",
    stroke: "#7130F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 241,
    width: 62,
    height: 8,
    rx: 4,
    fill: "#C9D2E6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 238,
    width: 14,
    height: 14,
    rx: 4,
    fill: "#F6F2FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 244,
    r: 3,
    fill: "#7130F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 241,
    width: 46,
    height: 8,
    rx: 4,
    fill: "#C9D2E6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#sh)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 250,
    r: 26,
    fill: "#1B3B6F"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 249,
    width: 22,
    height: 16,
    rx: 4,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245 249v-4a7 7 0 0114 0v4",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 257,
    r: 2.4,
    fill: "#1B3B6F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 78,
    r: 6,
    fill: "#C9B6FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 132,
    r: 4,
    fill: "#A9C7FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 232,
    r: 4,
    fill: "#9B6BFF",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIllustration);
export default __webpack_public_path__ + "static/media/customer-illustration.4ced13c61b5e0d8a5071a2fa8c95e0a8.svg";
export { ForwardRef as ReactComponent };